import React from 'react';
import { MdLock } from 'react-icons/md';
import Modal from '../ui/Modal';
import Button from '../ui/Button';

export default function DemoUnauthorizedModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Action Unauthorized" size="sm">
      <div className="flex flex-col items-center text-center gap-4 py-2">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-warning-light text-warning">
          <MdLock className="h-6 w-6" />
        </div>
        <p className="text-sm text-neutral-700">
          Demo accounts cannot perform this action. You have view-only access to
          the system.
        </p>
        <Button onClick={onClose} className="mt-2">
          Got it
        </Button>
      </div>
    </Modal>
  );
}
